<ion-searchbar padding placeholder="{{ 'Search' | translate }}" (ionInput)="getItems($event)"></ion-searchbar>